var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.config,"value":_vm.data},on:{"input":(e) => _vm.$emit('update:data', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }